export default "__VITE_ASSET__zMvmZ$Tk__"